
<template>
  <div>
    <b-form
      v-if="!paymentSent"
      @submit="sendPayment"
    >
      <h5>{{ $t('auction.price_to_be_payed') }}: {{ price | money }}</h5>
      <b-form-group
        :label="$t('auction.card.pan')"
        :state="isPanValid"
        :invalid-feedback="$t('auction.card.invalid')"
      >
        <the-mask
          v-model="cardPan"
          class="ant-input"
          mask="#### #### #### ####"
          placeholder="#### #### #### ####"
        />
      </b-form-group>
      <b-form-group
        :label="$t('auction.card.expiry')"
        :state="isExpiryValid"
        :invalid-feedback="$t('auction.card.invalid')"
      >
        <the-mask
          v-model="expiry"
          class="ant-input expiry"
          mask="## / ##"
          placeholder="ММ / ГГ"
          masked
        />
      </b-form-group>
      <b-button
        class="mb-3"
        type="submit"
        :disabled="submitDisabled"
      >
        {{ $t('auction.pay') }}
      </b-button>
      <b-alert
        v-model="errorAlert.isShow"
        dismissible
        fade
        variant="danger"
      >
        {{ errorAlert.message }}
      </b-alert>
    </b-form>
    <b-form
      v-else
      @submit="handleConfirm"
    >
      <b-form-group
        :label="$t('auction.enter_otp')"
      >
        <the-mask
          v-model="otp"
          class="ant-input otp"
          mask="# # # # # #"
          placeholder="# # # # # #"
        />
      </b-form-group>
      <b-button
        class="mb-3"
        :disabled="submitDisabled || otp.toString().length < 6"
        type="submit"
      >
        {{ $t('common.send') }}
      </b-button>
      <b-alert
        v-model="errorAlert.isShow"
        dismissible
        fade
        variant="danger"
      >
        {{ errorAlert.message }}
      </b-alert>
    </b-form>
  </div>
</template>

<script>
import auctionService from '@/services/api/manager/auction-service'

import { cardPanCheck, expiryCheck } from '@/utils/card-validator'

export default {
  name: 'PrizePayment',
  props: {
    auctionId: {
      type: String,
      default: () => '',
    },
    price: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      cardPan: '',
      expiry: '',
      otp: '',
      isOtpValid: null,
      isPanValid: null,
      isExpiryValid: null,
      paymentSent: false,
      submitDisabled: false,
      holdId: null,
      errorAlert: {
        isShow: false,
        variand: 'danger',
      },
    }
  },

  computed: {
    swappedExpiry() {
      const [year, month] = this.expiry.toString().split('/')
      return [month.trim(), year.trim()].join('')
    },
  },

  watch: {
    cardPan() {
      this.isPanValid = null
    },

    expiry() {
      this.isExpiryValid = null
    },
  },

  methods: {
    validatePan() {
      return cardPanCheck(this.cardPan)
    },
    validateExpiry() {
      return expiryCheck(this.swappedExpiry)
    },

    sendPayment(event) {
      event.preventDefault()
      this.isPanValid = this.cardPan.toString().length === 16 && !!this.validatePan()
      this.isExpiryValid = this.validateExpiry()

      if (this.isPanValid && this.isExpiryValid) {
        this.submitDisabled = true
        auctionService.sendPayment({
          pan: this.cardPan,
          expiry: this.swappedExpiry,
          auctionId: this.auctionId,
        }).then(({ data: { content } }) => {
          this.submitDisabled = false
          this.paymentSent = true
          this.holdId = content.hold_id
        })
          .catch(() => {
            this.submitDisabled = false
            this.errorAlert = {
              isShow: true,
              message: this.$t('auction.payment_messages.pay_error'),
            }
            setTimeout(() => {
              this.errorAlert = {
                isShow: false,
                message: '',
              }
            }, 5000)
          })
      }
    },

    handleConfirm(event) {
      event.preventDefault()
      this.submitDisabled = true
      const payload = {
        holdId: this.holdId,
        otp: this.otp,
      }
      auctionService.confirmPayment(payload)
        .then(() => {
          this.$router.go()
        })
        .catch(() => {
          this.paymentSent = false
          this.holdId = null
          this.errorAlert = {
            isShow: true,
            message: this.$t('auction.payment_messages.otp_error'),
          }
          setTimeout(() => {
            this.errorAlert = {
              isShow: false,
              message: '',
            }
          }, 5000)
        })
        .finally(() => {
          this.submitDisabled = false
        })
    },
  },
}
</script>

<style scoped>
  .otp,
  .expiry {
    width: 150px;
    text-align: center;
  }
</style>
